module.exports = new Promise(function (resolve, reject) {
    var __webpack_error__ = new Error();

    if (typeof window["xsollaPayCards"] !== 'undefined') {
      return resolve();
    }

    __webpack_require__.l(
      window["xsollaPayCardsRemoteUrl"] + '/remote-entry-xsolla-pay-cards.js',
      function (event) {
        if (typeof window["xsollaPayCards"] !== 'undefined') {
           return resolve();
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "xsollaPayCards",
    );
  }).then(function(){
    var proxy = {
      get: window["xsollaPayCards"].get,
      init: window["xsollaPayCards"].init
    }
    return proxy
  }).catch(function(e) {
    console.error('xsollaPayCards', e);
    let newProxy = {
      get: (module, scope) => () => [],
      init: () => {}
    }
    return(newProxy);
  });